import { NgModule } from "@angular/core";
import { BiSpinnerComponent } from "./bi-spinner.component";

/**
 * This module is only declared for backward compatibility - otherwise, use the BiSpinnerComponent as standalone component import
 */
@NgModule({
  imports: [BiSpinnerComponent],
  exports: [BiSpinnerComponent]
})
export class BiSpinnerModule {}
